import { Box, HStack, Icon, Image, Stack, Text } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { CollapsedText } from '@cronos-app/components';
import { ChevronRight, IconLinkOff } from '@cronos-app/icons';
import { CdcCardType } from '@ui/views/card-cronos/core/types';
import { useCdcDepositAddress } from '@ui/views/card-cronos/core/utils';
import { useTranslations } from 'next-intl';
import type { FC, MouseEventHandler } from 'react';
import { useCallback } from 'react';

import { useCardBindingStore } from '../CardBinding';
import { HomeDivider } from './HomeDivider';

export const CdcCard: FC<{ type: CdcCardType }> = ({ type }) => {
  const { data: address } = useCdcDepositAddress();
  const t = useTranslations();

  // TODO: check if we need it
  const onClick = useCallback<MouseEventHandler<HTMLDivElement>>((e) => {
    e.stopPropagation();
    useCardBindingStore.getState().open(false);
  }, []);
  return (
    <Box
      rounded="12px"
      bg={type === CdcCardType.None ? 'transparent' : 'gradients.sky-blue-20'}
      cursor="pointer"
      onClick={onClick}
    >
      {type !== CdcCardType.None && <HomeDivider />}
      <HStack
        p="3"
        gap="2"
        w={type === CdcCardType.None ? 'fit-content' : 'full'}
        mx="auto"
      >
        <Image
          src={getAssetUrl('/images/cdc-app.svg')}
          boxSize="60px"
          alt="CDC App"
        />
        <Stack flex="1">
          <CollapsedText
            w={
              type === CdcCardType.None
                ? {
                    base: '120px',
                    desktop: '140px',
                  }
                : {
                    base: '100px',
                    desktop: '120px',
                  }
            }
            remain={4}
            text={address ?? ''}
            textStyle={type === CdcCardType.None ? 'body1Bold' : 'body3'}
          />
          {type === CdcCardType.Second && (
            <Text textStyle="caption">
              {t('card.Only one linked wallet at a time')}
            </Text>
          )}
        </Stack>
        {type === CdcCardType.First && (
          <HStack gap="1">
            <Text color="brand.secondary-sky-blue" textStyle="body3Bold">
              {t('card.Top Up')}
            </Text>
            <Icon
              as={ChevronRight}
              boxSize="4"
              color="brand.secondary-sky-blue"
            />
          </HStack>
        )}
        {type === CdcCardType.Second && <Icon as={IconLinkOff} boxSize="5" />}
      </HStack>
      {type !== CdcCardType.None && <HomeDivider />}
    </Box>
  );
};
